// src/Dashboard/pages/admin/Attendance/components/AttendanceModeTabs.jsx
import React from "react";
import {
  FaChartLine,
  FaClipboardCheck,
  FaTable,
  FaTrashAlt,
} from "react-icons/fa";

const tabs = [
  {
    key: "call",
    label: "Faire l’appel",
    icon: FaClipboardCheck,
  },
  {
    key: "table",
    label: "Tableau d’appel",
    icon: FaTable,
  },
  {
    key: "charts",
    label: "Statistiques",
    icon: FaChartLine,
  },
  {
    key: "delete",
    label: "Supprimer des appels",
    icon: FaTrashAlt,
  },
];

export default function AttendanceModeTabs({ activePanel, onChange }) {
  return (
    <section className="rounded-3xl border border-slate-200 bg-white p-3 shadow-sm shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none">
      <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-4">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = activePanel === tab.key;

          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              className={`flex items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-bold transition ${
                active
                  ? "bg-slate-950 text-white shadow-lg shadow-slate-200/80 dark:bg-white dark:text-slate-950 dark:shadow-none"
                  : "bg-slate-50 text-slate-600 hover:bg-slate-100 dark:bg-slate-950 dark:text-slate-300 dark:hover:bg-slate-800"
              }`}
            >
              <Icon />
              {tab.label}
            </button>
          );
        })}
      </div>
    </section>
  );
}